import type { LocaleResources } from '../types';

/**
 * Settings screen UI string resources
 * Exchange, invest, notifier settings related
 */
export const settingStr: LocaleResources['settingStr'] = {
  exchange: {
    baseAssetType: 'Base Asset Type',
    baseAssetTypeTooltip: 'Quote currency to be used as an asset',
    useTestnet: 'Use Testnet',
    useHedgeMode: 'Use Hedge Mode',
    hedgeModeTooltip:
      'When enabled, you can hold both long and short positions for the same symbol simultaneously. When disabled, it operates in One-way mode.',
    tradingIp: 'Trading IP',
    additionalProxy: 'Additional Proxy IP',
    newProxyPlaceholder: 'New Proxy IP',
    holdings: 'Holdings',
  },
  invest: {
    seedBasis: 'Initial Seed Basis',
    evalSeedBasis: 'Evaluation Seed Basis',
    defaultSeedRatio: 'Default Seed Contribution Ratio',
    symbolAllocation: 'Per-Symbol Allocation Ratio',
    checkBreakInSameCandle: 'Check Breakout in Same Candle',
    tradeLimit: 'Trade Limit',
    tradeLimitCaption: 'Based on previous entry price in same candle',
    tradeLimitSuffix: 'Do not re-enter on change within',
    tradeErrorRetryLimit: 'Trade Error Retry Limit',
    tradeErrorRetrySuffix: 'Stop trading attempts during',
    virtualPositionHandling: 'Virtual Position Handling',
    backSignalPeriod: 'Back Signal Period',
    defaultBacktestPeriod: 'Default Backtest Period',
    indicatorBufferCandles: 'Indicator Buffer Candles',
    signalProfitCalcBasis: 'Signal Profit Calculation Basis',
    calcQuantity: 'Calculation Quantity',
    virtualSlippage: 'Virtual Trading Slippage',
    entryPriceErrorRange: 'Entry Price Error Range',
    entryPriceErrorRangeNote: '(Only applies when entering positions in [Virtual Investment] mode.)',
  },
  unit: {
    hours: 'hours',
    minutes: 'minutes',
    candles: 'candles',
    percent: '%',
  },
  notifier: {
    eventType: 'Event Type to Notify',
    sendMethod: 'Notification Method',
    allEvents: 'All',
    onlyType: '{type} only',
    apiToken: 'API Token',
    webhookUrl: 'Webhook URL',
    inputRequired: 'Please enter {field}.',
    selectNotifierType: 'Select notification method to add:',
    addNewNotifier: 'Add New Notification Method',
    restartRequired: 'Bot restart is required after stopping.',
  },
  form: {
    requiredMark: 'mark: Required field',
  },
  message: {
    restartRequired: 'The modified settings require stopping and restarting the investment to take effect.',
  },
  button: {
    reset: 'Reset',
    validatingProxy: 'Validating proxy...',
  },
  proxyError: {
    title: 'Proxy Connection Error',
    proxyIp: 'Problematic Proxy',
    instruction: 'Please check the proxy settings and enter a valid proxy IP.',
  },
  proxyValidation: {
    failedTitle: 'Proxy Validation Failed',
    multipleFailures: '{count} proxy connections failed',
    otherFailures: 'Other Failed Proxies',
    validationError: 'Proxy Validation Error',
    validationErrorMessage: 'An error occurred during proxy validation. Please try again later.',
    validatingWarning: 'Proxy validation in progress. Please wait a moment.',
  },
};
